<template>
    <div class="ml-2">
        <b-button variant="success" @click.stop="iniciarFinalizacao()"
            ><i class="fa fa-check"></i> Finalizar</b-button
        >
        <b-modal v-model="mostrarModal">
            <div slot="modal-title">
                Finalização de requisição com saldo a comprometer
            </div>
            <b-alert variant="warning" show
                ><i class="fa fa-exclamation-triangle fa-lg"></i
                ><strong>
                    Essa requisição tem saldo a comprometer. Após essa operação
                    a requisição ficará indisponível para alterações.</strong
                ></b-alert
            >
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label class="required">Justificativa</label>
                        <b-form-textarea
                            v-model="justificativa"
                            :rows="4"
                            @input.native="$v.justificativa.$touch()"
                            :state="$v.justificativa.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModal()"
                    class="mr-2"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarSalvar()"
                >
                    Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import RequisicoesServicos from './RequisicoesServicos'

export default {
    props: {
        requisicao: {
            type: Object
        }
    },

    data() {
        return {
            justificativa: null,
            mostrarModal: false,
            erros: []
        }
    },

    validations: {
        justificativa: {
            required
        }
    },

    methods: {
        iniciarFinalizacao() {
            if (
                this.requisicao.saldoASerRateado > 0 ||
                this.requisicao.saldoASerComprometido > 0
            ) {
                this.abrirModal()
            } else {
                this.confirmarSalvar()
            }
        },

        fecharModal() {
            this.justificativa = null
            this.$nextTick(() => {
                this.$v.$reset()
            })
            this.mostrarModal = false
        },

        abrirModal() {
            this.mostrarModal = true
        },

        confirmarSalvar() {
            this.$swal({
                title: 'Finalização da Requisição',
                html: `Confirma a finalização da requisição referente ao processo ${this.requisicao.processo}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.finalizarRequisicao()
                }
            })
        },

        finalizarRequisicao() {
            let requisicaoDto = {
                idRequisicao: this.requisicao.idRequisicao,
                justificativa: this.justificativa
            }
            this.$store.dispatch('addRequest')
            RequisicoesServicos.finalizar(requisicaoDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.$emit('obterRequisicaoAtualizada')
                        this.$store.dispatch('setRecarregar', true)
                        this.$toast.success(
                            'Requisição finalizada com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.fecharModal()
                    } else {
                        this.$toast.error(
                            `Erro ao finalizar requisição! ${response.errors[0]}`,
                            'OK',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
